export default __webpack_public_path__ + "static/background-090a3b4802bfb1e01b92e0e4eadc9c44.png";